import auth from "./auth"
import catalogo from './catalogo'
import activacion from './activacion'
import changePassword from './changePassword'

export default {
    namespaced: true,
    modules: {
        auth,
        catalogo,
        activacion,
        changePassword
    }
}